SupportUtils = require "../../../helpers/utils"
CommonBaseInputsView = require "../../common/views/common_base_inputs_view"
CallBackPhoneNumberModel = require "../../../models/call_back_phone_number_model"
HoldTimeModel = require "../../../models/hold_time_model"
SharedSpinnerView = require "../../../../../shared/frontend/views/spinner_view"
CallBackOptionSuccessView = require "./call_me_back_success_view"
EmailFormPhoneNumberInputView = require "../../common/views/phone_number_input"
EmailFormEmailInputView = require "../../common/views/phone_number_input"
EmailFormUserNameInputView = require "../INTL/user_name_input_view"
SupportPhoneNumberWithCallBackTemplate = require '../../../../phone_number_with_call_back.html.mustache'
SupportCallMeBackPhoneNumberObjectsTemplate = require '../../../../call_me_back_phone_number_objects.html.mustache'

class PhoneNumberCallBackView extends CommonBaseInputsView

  initialize: ->
    CommonBaseInputsView::initialize.apply(this, arguments)
    @template = SupportPhoneNumberWithCallBackTemplate
    @mainView = @options.mainView
    @model = new CallBackPhoneNumberModel()
    @holdTimeModel = new HoldTimeModel({mainView: this})
    @popupContainer = $('#popup')
    @spinnerView = new SharedSpinnerView()
    @inputObjects  = @model.getDefaultPhoneForm().objects
    @callBackSuccessView = new CallBackOptionSuccessView()

  render: ->
    GIG.Modal.open
      el: @popupContainer
      closeOnBgClick: true
      closeOnEscKey: true
    @$el.append toHtml(@template, @toHash(), @I18nScope)
    @popupContainer.html(@el)
    @showLoadingSpinner()
    @holdTimeModel.getCallMeBackFlag()

  getViewByObjectType:(obj) ->
    options =
      model: obj
      validateEmailForm: @validateEmailForm
      template: SupportCallMeBackPhoneNumberObjectsTemplate

    switch obj.type
      when 'phone_number'  then new EmailFormPhoneNumberInputView options
      when 'email_address' then new EmailFormEmailInputView options
      when 'user_name'     then new EmailFormUserNameInputView options

  callMeBackFlagCb: (response)=>
    @hideLoadingSpinner()
    if evaluate(response?.showCallMeOption)
      window.showDOMElems [$('.call-me-back-option'), $('#call-back-content-container')]
      @renderInputViews(@inputObjects, "#call-me-back-inputs")
    else
      @renderNormalPhoneNumberView()

  renderNormalPhoneNumberView: ()->
    @closeModal()
    @mainView.renderNormalPhoneNumberView()

  onSubmitClick: ()->
    CommonBaseInputsView::onSubmitClick.apply(this, arguments)

  submitForm: (data)->
    window.hideDOMElems $('.call-me-back-option')
    @showLoadingSpinner()
    @holdTimeModel.postToHoldTime(data)

  enableSubmit: ()->
    $('.call-back-submit-button', @$el).removeClass('opacity-half')
    CommonBaseInputsView::enableSubmit.apply(this, arguments)

  disableSubmit: ()->
    $('.call-back-submit-button', @$el).addClass('opacity-half')
    CommonBaseInputsView::disableSubmit.apply(this, arguments)

  renderHoldTimePostSuccess: (response)=>
    @holdTimeModel.set({'estWaitTime': response.est_wait_time})
    @hideLoadingSpinner()
    @closeModal()
    window.hideDOMElems [$('.help-wizard-content form'), $('.step-three #results'), $('.step-actions'), $('.contact-channels-v2-header')]
    @removeCallBackStepThree()
    propagateEventBeforeReplacingElements( () =>
      @callBackSuccessView.render({waitTime: @holdTimeModel.get("estWaitTime")})
      $('#help-wizard').append(@callBackSuccessView.el)
    )
    window.hideFooterLinks()

  removeCallBackStepThree: ->
    $('#help-wizard .horizontal')?.remove()

  renderHoldTimePostError: ()=>
    @hideLoadingSpinner()
    window.hideDOMElems $('.call-me-back-option')
    propagateEventBeforeReplacingElements( () =>
      @$el.find('#call-back-spinner').empty()
      window.showDOMElems $('.no-call-me-back-option')
    )

  hideLoadingSpinner:()->
    @$el.find('#call-back-spinner').empty()
    window.hideDOMElems @$el.find('#call-back-spinner')

  showLoadingSpinner:()->
    window.showDOMElems $('#call-back-spinner')
    SupportUtils.showLoading $('#call-back-spinner'), '150px'

  closeModal: ->
    GIG.Modal.close()
    return false

  events:
    'click .close-modal' : "closeModal"
    'click .b-close' : "closeModal"
    'click .submit-button': 'onSubmitClick'

module.exports = PhoneNumberCallBackView
